/* SET STATE */
export const SET_STATE_LABREQUESTREPORTAUX = "SET_STATE_LABREQUESTREPORTAUX"

/* LABREQUESTREPORTAUXS */
export const GET_LABREQUESTREPORTAUXS = "GET_LABREQUESTREPORTAUXS"
export const GET_LABREQUESTREPORTAUXS_SUCCESS = "GET_LABREQUESTREPORTAUXS_SUCCESS"
export const GET_LABREQUESTREPORTAUXS_FAIL = "GET_LABREQUESTREPORTAUXS_FAIL"

/* LABREQUESTREPORTAUX */
export const GET_LABREQUESTREPORTAUX = "GET_LABREQUESTREPORTAUX"
export const GET_LABREQUESTREPORTAUX_SUCCESS = "GET_LABREQUESTREPORTAUX_SUCCESS"
export const GET_LABREQUESTREPORTAUX_FAIL = "GET_LABREQUESTREPORTAUX_FAIL"

/**
 * ADD LABREQUESTREPORTAUX
 */
 export const ADD_NEW_LABREQUESTREPORTAUX = "ADD_NEW_LABREQUESTREPORTAUX"
 export const ADD_LABREQUESTREPORTAUX_SUCCESS = "ADD_LABREQUESTREPORTAUX_SUCCESS"
 export const ADD_LABREQUESTREPORTAUX_FAIL = "ADD_LABREQUESTREPORTAUX_FAIL"

 /**
 * UPDATE LABREQUESTREPORTAUX
 */
export const UPDATE_LABREQUESTREPORTAUX = "UPDATE_LABREQUESTREPORTAUX"
export const UPDATE_LABREQUESTREPORTAUX_SUCCESS = "UPDATE_LABREQUESTREPORTAUX_SUCCESS"
export const UPDATE_LABREQUESTREPORTAUX_FAIL = "UPDATE_LABREQUESTREPORTAUX_FAIL"

 /**
 * UPDATE LABREQUESTREPORTAUXCHECK
 */
  export const UPDATE_LABREQUESTREPORTAUXCHECK = "LABREQUESTREPORTAUXCHECK"


/**
 * DELETE LABREQUESTREPORTAUX
 */
export const DELETE_LABREQUESTREPORTAUX = "DELETE_LABREQUESTREPORTAUX"
export const DELETE_LABREQUESTREPORTAUX_SUCCESS = "DELETE_LABREQUESTREPORTAUX_SUCCESS"
export const DELETE_LABREQUESTREPORTAUX_FAIL = "DELETE_LABREQUESTREPORTAUX_FAIL"
